import { Button, Grid, IconButton, TextField, Typography } from '@material-ui/core'
import { FIELDS, SUPPLIER_CONTACT_TYPES } from 'lib'
import React from 'react'
import { ISupplier } from 'types'
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";

interface Props {
    handleChange: (key: string, value: any) => void
    supplier: ISupplier
}

const SupplierPaymentForm = ({ supplier, handleChange }: Props) => {

    const [emails, setEmails] = React.useState<string[]>([]);

    React.useEffect(() => {
        setEmails(
            supplier.accountExecutiveSupervisor
                ?.split(",")
                .map(email => email.trim()) || []
        );
    }, [supplier.accountExecutiveSupervisor]);

    const syncEmails = (list: string[]) => {
        setEmails(list);

        handleChange(
            "accountExecutiveSupervisor",
            list
                .map(e => e.trim())
                .filter(Boolean)
                .join(",")
        );
    };

    const addEmail = () => {
        // Si no hay correos aún, permite agregar el primero
        if (emails.length > 0) {
            const lastEmail = emails[emails.length - 1].trim();

            if (!lastEmail) {
                alert("Debe ingresar un correo antes de agregar otro.");
                return;
            }

            if (!isValidEmail(lastEmail)) {
                alert("El correo ingresado no es válido.");
                return;
            }
        }

        syncEmails([...emails, ""]);
    };

    const removeEmail = (index: number) => {
        syncEmails(emails.filter((_, i) => i !== index));
    };

    const handleEmailChange = (index: number, value: string) => {
        const list = [...emails];
        list[index] = value.toLowerCase(); // Siempre minúsculas
        syncEmails(list);
    };


    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const isValidEmail = (email: string) => emailRegex.test(email.trim());

    return (
        <div className="w-full">
            <Typography
                variant="body2"
                color="textSecondary"
                style={{
                    fontWeight: 600,
                    marginBottom: 10
                }}
            >
                Correos para pagos
            </Typography>

            <Grid container spacing={2}>
                {emails.map((email: string, index: number) => (
                    <Grid
                        item
                        xs={12}
                        key={index}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8
                        }}
                    >
                        <TextField
                            fullWidth
                            size="small"
                            placeholder="correo@empresa.com"
                            value={email}
                            inputProps={{
                                style: { textTransform: "lowercase" }
                            }}
                            onChange={(e) =>
                                handleEmailChange(index, e.target.value)
                            }
                            error={email.trim() !== "" && !isValidEmail(email)}
                            helperText={
                                email.trim() !== "" && !isValidEmail(email)
                                    ? "Correo electrónico inválido"
                                    : ""
                            }
                        />

                        <IconButton
                            onClick={() => removeEmail(index)}
                        >
                            <DeleteIcon />
                        </IconButton>
                    </Grid>
                ))}

                <Grid item xs={12}>
                    <Button
                        variant="outlined"
                        startIcon={<AddIcon />}
                        onClick={addEmail}
                    >
                        Agregar correo
                    </Button>
                </Grid>
            </Grid>
        </div>
    );
};

export default SupplierPaymentForm;